module.exports = __webpack_public_path__ + "img/3D_2BHK_t1.9dbf5365.png";